<template>
  <div class="container">
    <div class="nav" :style=" 'top: ' + navtop + 'px;'">
      <Btnav></Btnav>
    </div>

    <!-- <transition name="slide-fade">  
     
     <div class="banner" v-if="show" :style=" 'background-image: url(' + this.banner + ');'" @click="show = !show">
      <p class="bannerp1">大标题大标题</p>
      <p class="bannerp2">大树联合集团开创与xxxx年，主要从事电子商务、设计、程序等互联网业务</p>
     </div>
     
    </transition>-->

    <transition name="slide-fade">
      <div class="top">
        <el-carousel
          indicator-position="none"
          height="100%"
          :interval="3000"
          arrow="never"
          trigger="never"
        >
          <el-carousel-item v-for="(item,index) in banner" :key="index">
            <div class="banner" :style=" 'background-image: url(' + item + ');background-size: cover;'">
              <p class="bannerp1">{{bannertitle1}}</p>
              <p class="bannerp2">{{bannertitle2}}</p>
              <p class="bannerp2">{{bannertitle3}}</p>
              <img
                class="bannerimg"
                src="../../assets/dashu/bannerbottom.png"
                alt
                @click="routerdetails(1000)"
              />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </transition>

    <div class="about">
      <p class="text-linear">ABOUT US</p>
      <p class="text-title">{{aboutus}}</p>
      <!-- <p>关于我们</p> 
      <img src="../../assets/dashu/about2.png" alt="">-->
      <div class="about-div">
        <div class="about-div1"></div>
        <div class="about-div2">
          <div class="aboutExplain">{{aboutusdesc}}</div>
          <router-link to="Aabout">
            <div class="more">
              {{aboutusmore}}
              <i class="el-icon-arrow-right"></i>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <div class="news">
      <p class="text-linear">News Center</p>
      <p class="text-title">{{news}}</p>
      <span class="news-span">
        <router-link to="Anew">
          <span>
            {{newsmore}}
            <i class="el-icon-arrow-right"></i>
            <i class="el-icon-arrow-right"></i>
          </span>
        </router-link>
      </span>
      <div class="three">
        <div
          class="three1"
          :style=" 'background-image: url(' + this.newarray[0].image + ');'"
          @mouseenter="logoFlag1 = 1"
          @mouseleave="logoFlag1 = 0"
        >
          <div class="newtitle" v-if="logoFlag1">
            <span
              class="newtitle-span1"
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[0].title:this.newarray[0].title_en}}</span>
            <span
              class="newtitle-span2"
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[0].introduce:this.newarray[0].introduce_en}}</span>
            <span class="newtitle-span3" @click="routerdetails0() ">
              {{aboutusmore}}
              <i class="el-icon-arrow-right"></i>
            </span>
          </div>
          <div class="newtitle2" v-else>
            <span
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[0].title:this.newarray[0].title_en}}</span>
          </div>
        </div>
        <div
          class="three2"
          :style=" 'background-image: url(' + this.newarray[1].image + ');'"
          @mouseenter="logoFlag2 = 1"
          @mouseleave="logoFlag2 = 0"
        >
          <div class="newtitle" v-if="logoFlag2">
            <span
              class="newtitle-span1"
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[1].title:this.newarray[1].title_en}}</span>
            <span
              class="newtitle-span2"
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[1].introduce:this.newarray[1].introduce_en}}</span>
            <span class="newtitle-span3" @click="routerdetails1() ">
              {{aboutusmore}}
              <i class="el-icon-arrow-right"></i>
            </span>
          </div>
          <div class="newtitle2" v-else>
            <span
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[1].title:this.newarray[1].title_en}}</span>
          </div>
        </div>
        <div
          class="three3"
          :style=" 'background-image: url(' + this.newarray[2].image + ');'"
          @mouseenter="logoFlag3 = 1"
          @mouseleave="logoFlag3 = 0"
        >
          <div class="newtitle" v-if="logoFlag3">
            <span
              class="newtitle-span1"
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[2].title:this.newarray[2].title_en}}</span>
            <span
              class="newtitle-span2"
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[2].introduce:this.newarray[2].introduce_en}}</span>
            <span class="newtitle-span3" @click="routerdetails2() ">
              {{aboutusmore}}
              <i class="el-icon-arrow-right"></i>
            </span>
          </div>
          <div class="newtitle2" v-else>
            <span
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[2].title:this.newarray[2].title_en}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="about service">
      <p class="text-linear">Advantages and services</p>
      <p class="text-title">{{aas}}</p>
      <div class="service-con">
        <div class="service-item">
          <img class="service-icon" src="../../assets/dashu/sevice_1.png" alt />
          <!-- <img class="service-icon" :src="this.servicearray.operate_image" alt /> -->
          <div class="servic-title">{{service1}}</div>
          <div class="service-detail">
            <div>{{service1desc}}</div>
            <!-- <div>{{this.strs1[0]}}</div> -->
            <!-- <div>{{this.strs1[1]}}</div> -->
          </div>
        </div>

        <div class="service-item">
          <img class="service-icon" src="../../assets/dashu/service_2.png" alt />
          <!-- <img class="service-icon" :src="this.servicearray.management_image" alt /> -->
          <div class="servic-title">{{service2}}</div>
          <div class="service-detail">
            <div>{{service2desc}}</div>
            <!-- <div>{{this.strs2[0]}}</div> -->
            <!-- <div>{{this.strs2[1]}}</div> -->
          </div>
        </div>

        <div class="service-item" style="margin-bottom:60px">
          <img class="service-icon" src="../../assets/dashu/service_3.png" alt />
          <!-- <img class="service-icon" :src="this.servicearray.source_image" alt /> -->
          <div class="servic-title">{{service3}}</div>
          <div class="service-detail">
            <div>{{service3desc}}</div>
            <!-- <div>{{this.strs3[0]}}</div> -->
            <!-- <div>{{this.strs3[1]}}</div> -->
          </div>
        </div>

        <div class="service-item" style="margin-bottom:60px">
          <img class="service-icon" src="../../assets/dashu/service_4.png" alt />
          <!-- <img class="service-icon" :src="this.servicearray.logistics_image" alt /> -->
          <div class="servic-title">{{service4}}</div>
          <div class="service-detail">
            <div>{{service4desc}}</div>
            <!-- <div>{{this.strs4[0]}}</div> -->
            <!-- <div>{{this.strs4[1]}}</div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="about bread-about about2">
      <p class="text-linear">Cooperation brand</p>
      <p class="text-title">{{cb}}</p>
      <!-- <p>合作品牌</p> 
      <img src="../../assets/dashu/about2.png" alt="">-->
      <div class="cooperation">
        <!-- <div v-for="item in 32" :key="item">
          <img :src="require('../../assets/dashu/a/' + item + '.png')" alt="">
        </div>-->
        <!-- swiper -->
        <swiper class="swiper-con" :options="swiperOption">
          <!-- <swiper-slide v-for="slide in swiperSlides" :key="slide.title"> 
           <div class="slide-title">{{ slide.title }}</div>
           <div class="bread-con">
             <div class="bread-item" v-for="img in slide.breads" :key="img.url">
               <img class="img-size" :src="img.url" alt="品牌">
             </div>
           </div>
          </swiper-slide>-->
          <swiper-slide>
            <div class="slide-title">{{cb1}}</div>
            <div class="bread-con">
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/3.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/15.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/18.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/13.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/26.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/24.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/19.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/31.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/18.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/23.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/27.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/12.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/4.png" alt="品牌" />
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide-title">{{cb2}}</div>
            <div class="muying-con">
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/2.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/1.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/9.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/17.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/10.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/25.png" alt="品牌" />
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide-title">{{cb3}}</div>
            <div class="food-con">
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/6.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/7.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/30.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/14.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/22.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/16.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../../assets/dashu/a/29.png" alt="品牌" />
              </div>
            </div>
          </swiper-slide>

          <div class="swiper-button-prev swiper-black" slot="button-prev">
            <img src="../../assets/dashu/swiper_next.png" alt />
          </div>
          <div class="swiper-button-next swiper-white" slot="button-next">
            <img src="../../assets/dashu/swiper_next.png" alt />
          </div>
          <!-- 白色 -->
          <!-- <div class="swiper-button-next" slot="button-next"></div> -->
        </swiper>
      </div>
    </div>

    <!-- <div class="homeback"></div> -->

    <Btfooter></Btfooter>
  </div>
</template>
<script>
import animate from "animate.css";
import Btnav from "../../components/dashu/nav";
import Btfooter from "../../components/dashu/footer";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: { Btnav, Btfooter, swiper, swiperSlide },
  name: "Enter",
  data() {
    return {
      strs1: [],
      strs2: [],
      strs3: [],
      strs4: [],
      servicearray: {
        operate_image: ""
      },
      logoFlag1: 0,
      logoFlag2: 0,
      logoFlag3: 0,
      navtop: 0,
      // title:'',
      bannerUrl: "",
      detail: "",
      banner: [],
      bannerb: true,
      show: true,
      newarray: [
        {
          title: ""
        },
        {
          title: ""
        },
        {
          title: ""
        }
      ],
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        setWrapperSize: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          navigationHide: function() {
            alert("按钮隐藏了");
          }
        },
        disabledClass: "my-button-disabled",
        hiddenClass: "my-button-hidden"
      },
      swiperSlides: [
        {
          title: "美妆",
          breads: [
            { url: require("../../assets/dashu/a/3.png") },
            { url: require("../../assets/dashu/a/15.png") },
            { url: require("../../assets/dashu/a/28.png") },
            { url: require("../../assets/dashu/a/13.png") },
            { url: require("../../assets/dashu/a/26.png") },
            { url: require("../../assets/dashu/a/24.png") },
            { url: require("../../assets/dashu/a/19.png") },
            { url: require("../../assets/dashu/a/31.png") },
            { url: require("../../assets/dashu/a/18.png") },
            { url: require("../../assets/dashu/a/23.png") },
            { url: require("../../assets/dashu/a/27.png") },
            { url: require("../../assets/dashu/a/12.png") },
            { url: require("../../assets/dashu/a/4.png") }
          ]
        },
        {
          title: "母婴",
          breads: [
            {
              url: require("../../assets/dashu/a/3.png")
            }
          ]
        },
        {
          title: "食品",
          breads: [
            {
              url: require("../../assets/dashu/a/3.png")
            }
          ]
        }
      ],
      ischinese: "cn",
      bannertitle1: "大树联合集团",
      bannertitle2: "大树联合集团开创于2018年，主要从事电子商",
      bannertitle3: "务、设计、程序等互联网业务",
      aboutus: "关于我们",
      aboutusdesc:
        "专注以提供品牌电子商务为核心的一站式商业解决方案，涉及店铺运营、数字营销、IT解决方案、仓储配送、客户服务等五大内容",
      aboutusmore: "了解更多",
      news: "新闻中心",
      newsmore: "查看更多",
      aas: "优势及服务",
      service1: "品牌代运管理",
      service1desc: "严格挑选境外品牌，良好的电商业务水平帮助品牌本土化定位及落地策略，确保长期深度战略合作化",
      service2: "多模式渠道管理",
      service2desc: "整合各类可触达的渠道，主流线上平台以及线下渠道覆盖，建立高效、精准可衡量的渠道跨屏营销体系",
      service3: "供应链管理",
      service3desc: "一站式清关服务，国际专线、跨境电商、智能保税仓储服务、国内配送，快速高效供应，无忧体验",
      service4: "数据管理",
      service4desc: "多年在电商行业精耕细作，掌握庞大电商行业数据，千万级粉丝经营、大数据管理经验",
      cb: "合作品牌",
      cb1: "美妆",
      cb2: "母婴",
      cb3: "食品",
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    routerdetails(topnum) {
      //  this.kakatopnum = topnum
      //  $("html,body").animate({ scrollTop:  $(".nav").offset().top - 100 + "px"},800);
      document.documentElement.scrollTop = topnum;
      document.body.scrollTop = topnum;
    },
    showIcon() {
      // console.log(document.documentElement.scrollTop)
      // console.log(document.body.scrollTop)
      if (document.body.scrollTop === 0) {
        this.navtop = document.documentElement.scrollTop;
      } else {
        this.navtop = document.body.scrollTop;
      }

      if (document.documentElement.scrollTop > 900) {
        this.navtop = 900;
      }
      if (document.body.scrollTop > 900) {
        this.navtop = 900;
      }
    },
    routerdetails0() {
      this.$router.push({
        name: "Anews",
        query: { detailsid: this.newarray[0].id }
      });
    },
    routerdetails1() {
      this.$router.push({
        name: "Anews",
        query: { detailsid: this.newarray[1].id }
      });
    },
    routerdetails2() {
      this.$router.push({
        name: "Anews",
        query: { detailsid: this.newarray[2].id }
      });
    }
  },
  created() {
    this.ischinese = window.localStorage.getItem("ischinese") || "cn";

    this.$http
      .post("/api/dashu/service/serviceList", {})
      .then(res => {
        // console.log(res.data.data)
        var code = res.data.code;
        if (code === 0) {
          if (this.ischinese == "cn") {
            // this.banner = res.data.data.banner.image;
            this.servicearray = res.data.data.lists;
            // console.log(this.banner)
            var str1 = res.data.data.lists.operate;
            var strs1 = str1.split("\n");
            this.strs1 = strs1;

            var str2 = res.data.data.lists.management;
            var strs2 = str2.split("\n");
            this.strs2 = strs2;

            var str3 = res.data.data.lists.source;
            var strs3 = str3.split("\n");
            this.strs3 = strs3;

            var str4 = res.data.data.lists.logistics;
            var strs4 = str4.split("\n");
            this.strs4 = strs4;
          } else if (this.ischinese == "en") {
            // this.banner = res.data.data.banner.image;
            this.servicearray = res.data.data.lists;
            // console.log(this.banner)
            var str1 = res.data.data.lists.operate_en;
            var strs1 = str1.split("\n");
            this.strs1 = strs1;

            var str2 = res.data.data.lists.management_en;
            var strs2 = str2.split("\n");
            this.strs2 = strs2;

            var str3 = res.data.data.lists.source_en;
            var strs3 = str3.split("\n");
            this.strs3 = strs3;

            var str4 = res.data.data.lists.logistics_en;
            var strs4 = str4.split("\n");
            this.strs4 = strs4;
          }
        }
      })
      .catch(function(error) {
        //  console.log(error);
      });
    if (this.ischinese == "en") {
      this.bannertitle1 = "Dashu United Group";
      this.bannertitle2 =
        "Founded in 2018, Dashu united group is mainly engaged in ";
      this.bannertitle3 =
        "e-commerce, design, program and other Internet businesses";
      this.aboutus = "ABOUT US";
      this.aboutusdesc =
        "Focus on providing brand e-commerce as the core of one-stop business solutions, involving store operation, digital marketing, it solutions, warehousing and distribution, customer service, etc";
      this.aboutusmore = "Learn more";
      this.news = "News Center";
      this.newsmore = "View more";
      this.aas = "Advantages and services";
      this.service1 = "BrandTransportationManagement";
      this.service1desc = "We strictly select overseas brands. A good e-commerce business level is conducive to brand localization positioning and landing strategy, ensuring the depth of long-term strategic cooperation.";
      this.service2 = "Multi-modeChannelManagement";
      this.service2desc = "We will integrate all kinds of accessible channels, and mainstream online platforms and offline channel coverage to establish an efficient, accurate and measurable channel cross-screen marketing system.";
      this.service3 = "SupplyChainManagement";
      this.service3desc = "One-stop customs clearance service, international dedicated line, cross-border e-commerce, intelligent bonded warehousing service, domestic distribution, fast and efficient supply, and worry-free experience";
      this.service4 = "DataManagement";
      this.service4desc = "We have worked intensively in the e-commerce industry for many years and have mastered huge e-commerce industry data. We have tens of millions of fans and big data management experience.";
      this.cb = "Cooperation brand";
      this.cb1 = "Beauty makeup";
      this.cb2 = "Mother and infant";
      this.cb3 = "Food";
    }
    this.$http
      .post("/api/dashu/index/bannerList", {})
      .then(res => {
        console.log(res.data.data)
        var code = res.data.code;
        if (code === 0) {
          this.banner = res.data.data.banner.image;
          console.log(this.banner)
          this.newarray = res.data.data.new;
          //  console.log(this.newarray)
        }
      })
      .catch(function(error) {
        //  console.log(error);
      });
  },
  mounted() {
    window.addEventListener("scroll", this.showIcon);
  }
};
</script>
<style scoped>
body {
  position: relative;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
.container {
  /* background-color:rgb(244,247,250); */
  background-color: white;
  min-width: max-content;
  min-width: -moz-max-content;
}
.nav {
  overflow: hidden !important;
  position: relative;
  z-index: 10;
  width: 100%;
  min-width: 1200px;
  /* background-size: cover; */
  background-position: center center;
  background-repeat: no-repeat;
}
.el-carousel--horizontal {
  overflow-x: hidden;
  height: 966px;
}
.top {
  height: 965px;
  overflow: hidden !important;
  position: relative;
  top: -56px;
  /* background-size: cover; */
  background-position: center center;
  background-repeat: no-repeat;
  width: 100%;
  min-width: 1200px;
  height: 965px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.banner {
  overflow: hidden !important;
  position: relative;
  /* background-size: cover; */
  background-position: center center;
  background-repeat: no-repeat;
  width: 100%;
  min-width: 1200px;
  height: 965px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-align: center;
}
.bannerp1 {
  /* position: absolute;
  top: 230px;
  left: 400px; */
  text-align: center;
  font-size: 54px;
  font-weight: bold;
  color: white;
  margin-top: 250px;
}
.bannerp2 {
  margin: 0 auto;
  font-size: 22px;
  line-height: 35px;
  width: 670px;
  overflow: hidden;
  display: -webkit-box;
  /* -webkit-line-clamp: 2; */
  -webkit-box-orient: vertical;
  color: white;
  text-align: center;
}
.about {
  overflow: hidden !important;
  position: relative;
  width: 1200px;
  height: 654px;
  margin: 100px auto 50px;
  text-align: center;
}
.bread-about {
  overflow: hidden !important;
  position: relative;
  width: 1200px;
  height: 654px;
  margin: 100px auto 50px;
  text-align: center;
}
.about2 {
  margin: 100px auto 100px;
  height: 850px;
}
.about p {
  text-align: center;
  margin: 0 0 20px 0;
  font-size: 30px;
  font-weight: bold;
}
/* .about img {
  position: absolute;
  top: 35px;
  left: 20%;
}  */
.about-div {
  margin: 93px 0 150px 0;
  height: 425px;
  display: flex;
}
.about-div1 {
  background-image: url("../../assets/dashu/index_about.png");
  background-size: 100%;
  margin-left: 30px;
  width: 683px;
  height: 436px;
}
.about-div1:hover {
  box-shadow: 0px 0px 20px #888888;
}
.about-div2 {
  width: 487px;
  margin-left: 30px;
}
.aboutExplain {
  margin-top: 60px;
  text-align: left;
  color: #888888;
  font-size: 16px;
  line-height: 28px;
}
.more {
  background: #76c3a2;
  color: white;
  font-size: 16px;
  line-height: 30px;
  width: 126px;
  height: 30px;
  border-radius: 5px;
  position: absolute;
  bottom: 100px;
  cursor: pointer;
}
.cooperation {
  /* display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap; */
  margin: 0 auto;
  margin-top: 40px;
  width: 100%;
  height: 670px;
}
.cooperation .swiper-con {
  width: 100%;
  height: 100%;
}
/* .cooperation div {
  position: relative;
  width: 140px;
  height: 115px;
  text-align: center;
  width: 10.7%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px; 
} */
/* .cooperation div img { 
  width: 134px;
  height: 117px;
  position: absolute;
  top: 0;
  left: 0;
} */
.slide-title {
  width: 100%;
  padding: 20px;
  font-size: 36px;
  color: #333333;
  text-align: left;
}
.news {
  /* overflow: hidden !important; */
  position: relative;
  width: 1200px;
  /* height: 654px; */
  text-align: center;
  margin: 100px auto 100px;
}
/* .news{
  background: #888888; 
  overflow: hidden !important;
  position: relative;
  width: 100%;
  min-width: 1200px;
  height: 490px;
  text-align: center;
}   */
.news p {
  text-align: center;
  margin: 0 0 20px 0;
  font-size: 30px;
  font-weight: bold;
}
.news img {
  position: absolute;
  top: 35px;
  left: 20%;
}
.news-span span {
  color: #888888;
  position: absolute;
  right: 0px;
}
.three {
  width: 1200px;
  margin: 110px auto 0;
  display: -ms-flexbox;
  display: flex;
}
.three1,
.three2,
.three3 {
  width: 30%;
  height: 403px;
  position: relative;
  box-shadow: 10px 0px 20px#888888;
}
.three1 {
  /* background-image: url('../../assets/dashu/new1.png'); */
  background-size: cover;
}
.three2 {
  margin: 0 5%;
  /* background-image: url('../../assets/dashu/new2.png'); */
  background-size: cover;
}
.three3 {
  /* background-image: url('../../assets/dashu/new2.png'); */
  background-size: cover;
}
.newtitle {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  padding: 5%;
  width: 100%;
  height: 100%;
  text-align: left;
  background: #888888;
  border-right: 1px solid #888888;
  opacity: 0.8;
}
.newtitle-span1 {
  color: white;
  text-align: left;
  font-size: 22px;
  line-height: 30px;
  font-weight: bold;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* autoprefixer:off */
  -webkit-box-orient: vertical;
  /* autoprefixer:on */
}
.newtitle-span2 {
  color: white;
  text-align: left;
  font-size: 14px;
  line-height: 24px;
  margin: 20px 0 0px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /* autoprefixer:off */
  -webkit-box-orient: vertical;
  /* autoprefixer:on */
}
.newtitle-span3 {
  color: white;
  text-align: right;
  font-size: 16px;
  line-height: 17px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /* autoprefixer:off */
  -webkit-box-orient: vertical;
  /* autoprefixer:on */
  cursor: pointer;
  position: absolute;
  right: 23px;
  bottom: 26px;
}
.newtitle2 {
  position: absolute;
  bottom: 0;
  padding: 5%;
  width: 90%;
  text-align: left;
  background: #ffffff;
  border-right: 1px solid #ffffff;
  opacity: 1;
}
.newtitle2 span {
  text-align: left;
  font-size: 22px;
  line-height: 28px;
  font-weight: bold;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* autoprefixer:off */
  -webkit-box-orient: vertical;
  /* autoprefixer:on */
}
.homeback {
  height: 688px;
  width: 100%;
  position: absolute;
  top: 2327px;
  background: #888888;
  /* opacity: 0.1; */
  z-index: -1;
}
.bannerimg {
  position: absolute;
  bottom: 40px;
  left: 49.5%;
  cursor: pointer;
}
.bannerimg:hover {
  bottom: 30px;
  padding-top: 10px;
}
.about .text-linear {
  text-align: center;
  margin: 0 0 20px 0;
  font-size: 65px;
  font-weight: bold;
  background-image: -webkit-gradient(
    linear,
    0 0,
    0 bottom,
    from(#e9fcf3),
    to(transparent)
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.about .text-title {
  text-align: center;
  color: #59ad89;
  font-size: 48px;
  font-weight: bold;
  margin-top: -60px;
}
.news .text-linear {
  text-align: center;
  margin: 0 0 20px 0;
  font-size: 65px;
  font-weight: bold;
  background-image: -webkit-gradient(
    linear,
    0 0,
    0 bottom,
    from(#e9fcf3),
    to(transparent)
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.news .text-title {
  text-align: center;
  color: #59ad89;
  font-size: 48px;
  font-weight: bold;
  margin-top: -60px;
}
.bread-con {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: flex-start;
  width: 95%;
  height: 582px;
  margin: 0 auto;
  border-radius: 10px;
  background: #f9f9f9;
  background-image: url("../../assets/dashu/mz_bg.png");
  background-size: 100% 100%;
  background-position: right bottom;
  overflow: hidden;
}
.muying-con {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: flex-start;
  width: 95%;
  height: 582px;
  margin: 0 auto;
  border-radius: 10px;
  background: #f9f9f9;
  background-image: url("../../assets/dashu/my_bg.png");
  background-size: 100% 100%;
  background-position: right bottom;
  overflow: hidden;
}
.food-con {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: flex-start;
  width: 95%;
  height: 582px;
  margin: 0 auto;
  border-radius: 10px;
  background: #f9f9f9;
  background-image: url("../../assets/dashu/food_bg.png");
  background-size: 100% 100%;
  background-position: right bottom;
  overflow: hidden;
}
.bread-item {
  /* position: relative;
  width: 132px;
  height: 95px;
  line-height: 95px;
  border-radius: 10px; */
  /* flex-grow: 1; */
  width: 30%;
  /* height: 95px; */
  box-sizing: border-box;
  margin: 10px 0 0 10px;
  border-radius: 10px;
  overflow: hidden;
}
.img-size {
  width: 100%;
  height: 100%;
  transform: scale(1.1, 1.1);
}
.service {
  background: #76c3a2;
  width: 100%;
  height: auto;
}
.service .text-title {
  color: #fff;
}
.service .text-linear {
  background-image: -webkit-gradient(
    linear,
    0 0,
    0 bottom,
    from(#88d7b5),
    to(transparent)
  );
}
.service-con {
  display: flex;
  flex-wrap: wrap;
  width: 1400px;
  margin: 0 auto;
}
.service-item {
  width: 510px;
  margin: 0 62px;
  margin-top: 50px;
}
.service-icon {
  width: 212px;
  height: 210px;
}
.servic-title {
  padding: 25px 0;
  color: #fff;
  font-size: 30px;
}
.service-detail {
  font-size: 18px;
  color: #fff;
  line-height: 36px;
  font-weight: lighter;
  text-align: left;
}
.swiper-white {
  /* position: relative; */
  background: #fff;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  /* opacity: 1; */
}
.swiper-white img {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 16px;
  height: 26px;
  margin-top: -13px;
  margin-left: -6px;
}
.swiper-black {
  background: #fff;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  /* opacity: 1; */
}
.swiper-black img {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 16px;
  height: 26px;
  margin-top: -13px;
  margin-left: -10px;
  transform: rotate(180deg);
}
.my-button-disabled {
  opacity: 0.8 !important;
}
.my-button-hidden {
  opacity: 0.8 !important;
}
</style>




// WEBPACK FOOTER //
// src/pages/pcPages/Ahome.vue